import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=7a3484dc&"
import script from "./project.js?vue&type=script&lang=js&"
export * from "./project.js?vue&type=script&lang=js&"
import style0 from "./Project.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports